import { render, staticRenderFns } from "./LibertyRxForm.vue?vue&type=template&id=4826eb35&scoped=true&"
import script from "./LibertyRxForm.vue?vue&type=script&lang=js&"
export * from "./LibertyRxForm.vue?vue&type=script&lang=js&"
import style0 from "./LibertyRxForm.vue?vue&type=style&index=0&id=4826eb35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826eb35",
  null
  
)

export default component.exports